import React from "react";
import styles from "../nicepage.module.css";

const FooterComponent = (props) => {
  return (
    <footer
      className={`${styles["u-clearfix"]} ${styles["u-footer"]} ${styles["u-grey-80"]}`}
      id="sec-fdb5"
    >
      <div
        className={`${styles["u-clearfix"]} ${styles["u-sheet"]} ${styles["u-sheet-1"]}`}
      >
        <div
          className={`${styles["u-clearfix"]} ${styles["u-expanded-width"]} ${styles["u-layout-wrap"]} ${styles["u-layout-wrap-1"]}`}
        >
          <div className={`${styles["u-layout"]}`}>
            <div className={`${styles["u-layout-row"]}`}>
              <div
                className={`${styles["u-size-20"]} ${styles["u-size-30-md"]}`}
              >
                <div className={`${styles["u-layout-col"]}`}>
                  <div
                    className={`${styles["u-container-style"]} ${styles["u-layout-cell"]} ${styles["u-size-60"]} ${styles["u-layout-cell-1"]}`}
                  >
                    <div
                      className={`${styles["u-container-layout"]} ${styles["u-container-layout-1"]}`}
                    >

                    <a
                      href="https://nicepage.com/c/text-website-templates"
                      className={`${styles["u-active-none"]} ${styles["u-bottom-left-radius-0"]} ${styles["u-bottom-right-radius-0"]} ${styles["u-btn"]} 
        ${styles["u-btn-rectangle"]} ${styles["u-button-style"]} ${styles["u-hover-none"]} ${styles["u-none"]} ${styles["u-radius-0"]} 
        ${styles["u-top-left-radius-0"]} ${styles["u-top-right-radius-0"]} ${styles["u-btn-1"]}`}
                    >
                      <span className={`${styles["u-icon"]}`}>
                        <svg
                          className={`${styles["u-svg-content"]}`}
                          viewBox="0 0 405.333 405.333"
                          x="0px"
                          y="0px"
                          style={{ width: "1em", height: "1em" }}
                        >
                          <path d="M373.333,266.88c-25.003,0-49.493-3.904-72.704-11.563c-11.328-3.904-24.192-0.896-31.637,6.699l-46.016,34.752    c-52.8-28.181-86.592-61.952-114.389-114.368l33.813-44.928c8.512-8.512,11.563-20.971,7.915-32.64    C142.592,81.472,138.667,56.96,138.667,32c0-17.643-14.357-32-32-32H32C14.357,0,0,14.357,0,32    c0,205.845,167.488,373.333,373.333,373.333c17.643,0,32-14.357,32-32V298.88C405.333,281.237,390.976,266.88,373.333,266.88z"></path>
                        </svg>
                        <img />
                      </span>
                      &nbsp;&nbsp;+91 -&nbsp;7981926017
                    </a>

                    <a
                      href="mailto:sshortinetworks@gmail.com"
                      className={`${styles["u-active-none"]} ${styles["u-bottom-left-radius-0"]} ${styles["u-bottom-right-radius-0"]} ${styles["u-btn"]} 
        ${styles["u-btn-rectangle"]} ${styles["u-button-style"]} ${styles["u-hover-none"]} ${styles["u-none"]} ${styles["u-radius-0"]} 
        ${styles["u-top-left-radius-0"]} ${styles["u-top-right-radius-0"]} ${styles["u-btn-2"]}`}
                    >
                      <span className={`${styles["u-icon"]}`}>
                        <svg
                          className={`${styles["u-svg-content"]}`}
                          viewBox="0 0 24 16"
                          x="0px"
                          y="0px"
                          style={{ width: "1em", height: "1em" }}
                        >
                          <path
                            fill="currentColor"
                            d="M23.8,1.1l-7.3,6.8l7.3,6.8c0.1-0.2,0.2-0.6,0.2-0.9V2C24,1.7,23.9,1.4,23.8,1.1z M21.8,0H2.2
        c-0.4,0-0.7,0.1-1,0.2L10.6,9c0.8,0.8,2.2,0.8,3,0l9.2-8.7C22.6,0.1,22.2,0,21.8,0z M0.2,1.1C0.1,1.4,0,1.7,0,2V14
        c0,0.3,0.1,0.6,0.2,0.9l7.3-6.8L0.2,1.1z M15.5,9l-1.1,1c-1.3,1.2-3.6,1.2-4.9,0l-1-1l-7.3,6.8c0.2,0.1,0.6,0.2,1,0.2H22
        c0.4,0,0.6-0.1,1-0.2L15.5,9z"
                          ></path>
                        </svg>
                        <img />
                      </span>
                      &nbsp;&nbsp;&nbsp;sshortinetworks@gmail.com
                    </a>

                    <p
                      className={`${styles["u-custom-font"]} ${styles["u-font-lobster"]} ${styles["u-text"]} ${styles["u-text-default"]} 
        ${styles["u-text-1"]}`}
                    >
                      <span
                        className={`${styles["u-icon"]} ${styles["u-icon-3"]}`}
                      >
                        <svg
                          className={`${styles["u-svg-content"]}`}
                          viewBox="0 0 52 52"
                          x="0px"
                          y="0px"
                          style={{ width: "1em", height: "1em" }}
                        >
                          <path
                            style={{ fill: "currentColor" }}
                            d="M38.853,5.324L38.853,5.324c-7.098-7.098-18.607-7.098-25.706,0h0
        C6.751,11.72,6.031,23.763,11.459,31L26,52l14.541-21C45.969,23.763,45.249,11.72,38.853,5.324z M26.177,24c-3.314,0-6-2.686-6-6
        s2.686-6,6-6s6,2.686,6,6S29.491,24,26.177,24z"
                          ></path>
                        </svg>
                        <img />
                      </span>
                      &nbsp;&nbsp;&nbsp;Kadiyam, Andhra Pradesh - 533126
                      <br />
                        <br />
                        <br />
                    </p>
                    </div>
                  </div>
                </div>
            </div>
            <div className={`${styles["u-size-20"]} ${styles["u-size-30-md"]}`}>
              <div className={`${styles["u-layout-col"]}`}>
                <div
                  className={`${styles["u-container-style"]} ${styles["u-layout-cell"]} ${styles["u-size-60"]} ${styles["u-layout-cell-2"]}`}
                >
                  <div
                    className={`${styles["u-container-layout"]} ${styles["u-container-layout-2"]}`}
                  >
                    <p
                      className={`${styles["u-custom-font"]} ${styles["u-font-lobster"]} ${styles["u-text"]} ${styles["u-text-default"]} ${styles["u-text-2"]}`}
                    >
                      Datri Plants. We Care For You
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className={`${styles["u-size-20"]} ${styles["u-size-60-md"]}`}>
              <div className={`${styles["u-layout-col"]}`}>
                <div
                  className={`${styles["u-container-style"]} ${styles["u-layout-cell"]} ${styles["u-size-60"]} ${styles["u-layout-cell-3"]}`}
                >
                  <div
                    className={`${styles["u-container-layout"]} ${styles["u-container-layout-3"]}`}
                  >
                    <div
                      className={`${styles["u-align-left"]} ${styles["u-social-icons"]} ${styles["u-spacing-10"]} ${styles["u-social-icons-1"]}`}
                    >
                      <a
                        href=""
                        className={`${styles["u-social-url"]}`}
                        title="facebook"
                        target="_blank"
                      >
                        <span
                          className={`${styles["u-icon"]} ${styles["u-social-facebook"]} ${styles["u-social-icon"]} ${styles["u-icon-4"]}`}
                        >
                          <svg
                            className={`${styles["u-svg-link"]}`}
                            preserveAspectRatio="xMidYMin slice"
                            viewBox="0 0 112 112"
                          >
                            <use
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                              xlinkHref="#svg-121a"
                            ></use>
                          </svg>
                          <svg
                            className={`${styles["u-svg-content"]}`}
                            viewBox="0 0 112 112"
                            x="0"
                            y="0"
                            id="svg-121a"
                          >
                            <circle
                              fill="currentColor"
                              cx="56.1"
                              cy="56.1"
                              r="55"
                            ></circle>
                            <path
                              fill="#FFFFFF"
                              d="M73.5,31.6h-9.1c-1.4,0-3.6,0.8-3.6,3.9v8.5h12.6L72,58.3H60.8v40.8H43.9V58.3h-8V43.9h8v-9.2
        c0-6.7,3.1-17,17-17h12.5v13.9H73.5z"
                            ></path>
                          </svg>
                        </span>
                      </a>

                      <a
                        href=""
                        className={`${styles["u-social-url"]}`}
                        title="twitter"
                        target="_blank"
                      >
                        <span
                          className={`${styles["u-icon"]} ${styles["u-social-twitter"]} ${styles["u-social-icon"]} ${styles["u-icon-5"]}`}
                        >
                          <svg
                            className={`${styles["u-svg-link"]}`}
                            preserveAspectRatio="xMidYMin slice"
                            viewBox="0 0 112 112"
                          >
                            <use
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                              xlinkHref="#svg-4d93"
                            ></use>
                          </svg>
                          <svg
                            className={`${styles["u-svg-content"]}`}
                            viewBox="0 0 112 112"
                            x="0"
                            y="0"
                            id="svg-4d93"
                          >
                            <circle
                              fill="currentColor"
                              cx="56.1"
                              cy="56.1"
                              r="55"
                            ></circle>
                            <path
                              fill="#FFFFFF"
                              d="M83.8,47.3c0,0.6,0,1.2,0,1.7c0,17.7-13.5,38.2-38.2,38.2C38,87.2,31,85,25,81.2c1,0.1,2.1,0.2,3.2,0.2
                              c6.3,0,12.1-2.1,16.7-5.7c-5.9-0.1-10.8-4-12.5-9.3c0.8,0.2,1.7,0.2,2.5,0.2c1.2,0,2.4-0.2,3.5-0.5c-6.1-1.2-10.8-6.7-10.8-13.1
                              c0-0.1,0-0.1,0-0.2c1.8,1,3.9,1.6,6.1,1.7c-3.6-2.4-6-6.5-6-11.2c0-2.5,0.7-4.8,1.8-6.7c6.6,8.1,16.5,13.5,27.6,14
                              c-0.2-1-0.3-2-0.3-3.1c0-7.4,6-13.4,13.4-13.4c3.9,0,7.3,1.6,9.8,4.2c3.1-0.6,5.9-1.7,8.5-3.3c-1,3.1-3.1,5.8-5.9,7.4
                              c2.7-0.3,5.3-1,7.7-2.1C88.7,43,86.4,45.4,83.8,47.3z"
                            ></path>
                          </svg>
                        </span>
                      </a>

                      <a
                        href=""
                        className={`${styles["u-social-url"]}`}
                        title="instagram"
                        target="_blank"
                      >
                        <span
                          className={`${styles["u-icon"]} ${styles["u-social-icon"]} ${styles["u-social-instagram"]} ${styles["u-icon-6"]}`}
                        >
                          <svg
                            className={`${styles["u-svg-link"]}`}
                            preserveAspectRatio="xMidYMin slice"
                            viewBox="0 0 112 112"
                          >
                            <use
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                              xlinkHref="#svg-0c11"
                            ></use>
                          </svg>
                          <svg
                            className={`${styles["u-svg-content"]}`}
                            viewBox="0 0 112 112"
                            x="0"
                            y="0"
                            id="svg-0c11"
                          >
                            <circle
                              fill="currentColor"
                              cx="56.1"
                              cy="56.1"
                              r="55"
                            ></circle>
                            <path
                              fill="#FFFFFF"
                              d="M55.9,38.2c-9.9,0-17.9,8-17.9,17.9C38,66,46,74,55.9,74c9.9,0,17.9-8,17.9-17.9C73.8,46.2,65.8,38.2,55.9,38.2
                              z M55.9,66.4c-5.7,0-10.3-4.6-10.3-10.3c-0.1-5.7,4.6-10.3,10.3-10.3c5.7,0,10.3,4.6,10.3,10.3C66.2,61.8,61.6,66.4,55.9,66.4z"
                            ></path>
                            <path
                              fill="#FFFFFF"
                              d="M74.3,33.5c-2.3,0-4.2,1.9-4.2,4.2s1.9,4.2,4.2,4.2s4.2-1.9,4.2-4.2S76.6,33.5,74.3,33.5z"
                            ></path>
                            <path
                              fill="#FFFFFF"
                              d="M73.1,21.3H38.6c-9.7,0-17.5,7.9-17.5,17.5v34.5c0,9.7,7.9,17.6,17.5,17.6h34.5c9.7,0,17.5-7.9,17.5-17.5V38.8
                              C90.6,29.1,82.7,21.3,73.1,21.3z M83,73.3c0,5.5-4.5,9.9-9.9,9.9H38.6c-5.5,0-9.9-4.5-9.9-9.9V38.8c0-5.5,4.5-9.9,9.9-9.9h34.5
                              c5.5,0,9.9,4.5,9.9,9.9V73.3z"
                            ></path>
                          </svg>
                        </span>
                      </a>

                      <a
                        href="mailto:sshortinetworks@gmail.com?subject=Online%20Plants%20Query"
                        className={`${styles["u-social-url"]}`}
                        data-type="Email"
                        title="Email"
                        target="_blank"
                      >
                        <span
                          className={`${styles["u-icon"]} ${styles["u-social-email"]} ${styles["u-social-icon"]} ${styles["u-icon-7"]}`}
                        >
                          <svg
                            className={`${styles["u-svg-link"]}`}
                            preserveAspectRatio="xMidYMin slice"
                            viewBox="0 0 112 112"
                          >
                            <use
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                              xlinkHref="#svg-1411"
                            ></use>
                          </svg>
                          <svg
                            className={`${styles["u-svg-content"]}`}
                            viewBox="0 0 112 112"
                            x="0"
                            y="0"
                            id="svg-1411"
                          >
                            <circle
                              fill="currentColor"
                              cx="56.1"
                              cy="56.1"
                              r="55"
                            ></circle>
                            <path id="path3864" 
                              fill="#FFFFFF"
                              d="M27.2,28h57.6c4,0,7.2,3.2,7.2,7.2l0,0v42.7c0,3.9-3.2,7.2-7.2,7.2l0,0H27.2
                              c-4,0-7.2-3.2-7.2-7.2V35.2C20,31.1,23.2,28,27.2,28 M56,52.9l28.8-17.8H27.2L56,52.9 M27.2,77.7h57.6V43.5L56,61.3L27.2,43.5V77.7z"
                            ></path>
                          </svg>
                        </span>
                      </a>

                      <a
                        href=""
                        className={`${styles["u-social-url"]}`}
                        data-type="Google Plus"
                        title="Google Plus"
                        target="_blank"
                      >
                        <span
                          className={`${styles["u-icon"]} ${styles["u-social-google"]} ${styles["u-social-icon"]} ${styles["u-icon-8"]}`}
                        >
                          <svg
                            className={`${styles["u-svg-link"]}`}
                            preserveAspectRatio="xMidYMin slice"
                            viewBox="0 0 112 112"
                          >
                            <use
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                              xlinkHref="#svg-7ab2"
                            ></use>
                          </svg>
                          <svg
                            className={`${styles["u-svg-content"]}`}
                            viewBox="0 0 112 112"
                            x="0"
                            y="0"
                            id="svg-7ab2"
                          >
                            <circle
                              fill="currentColor"
                              cx="56.1"
                              cy="56.1"
                              r="55"
                            ></circle>
                            <path
                              fill="#FFFFFF"
                              d="M60.8,76.3c-6.6,8.6-19,11.1-29,7.7c-10.6-3.5-18.4-14.2-18.2-25.5C13,44.6,25.3,31.8,39.1,31.6
                              c7.1-0.6,14,2.1,19.3,6.6c-2.2,2.4-4.4,4.8-6.9,7.1c-4.8-2.9-10.4-5-15.9-3.1c-8.8,2.6-14.3,13-10.9,21.8
                              c2.7,9.1,13.7,14.1,22.5,10.2c4.5-1.6,7.5-5.7,8.7-10.2c-5.1-0.1-10.2,0-15.5-0.2c0-3,0-6.1,0-9.2c8.6,0,17.1,0,25.7,0
                              C66.7,62.3,65.5,70.4,60.8,76.3z M98.3,62.5c-2.6,0-5.1,0-7.7,0c0,2.6,0,5.1,0,7.7c-2.6,0-5.1,0-7.7,0c0-2.6,0-5.1,0-7.7
                              c-2.6,0-5.1,0-7.7,0c0-2.6,0-5.1,0-7.7c2.6,0,5.1,0,7.7,0c0-2.6,0-5.1,0.1-7.7c2.6,0,5.1,0,7.7,0c0,2.6,0,5.1,0,7.7
                              c2.6,0,5.1,0,7.7,0C98.3,57.3,98.3,59.9,98.3,62.5z"
                            ></path>
                          </svg>
                        </span>
                      </a>


                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default FooterComponent;
